<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <progress-bar :show="busy"></progress-bar>
        <v-card-title primary-title class="grey lighten-4">
          <h3 class="headline mb-0">{{ $t('settings') }}</h3>
        </v-card-title>
        <v-divider></v-divider>

        <v-tabs icons-and-text centered fixed>
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab href="#tab-password">
            {{ $t('password') }}
            <v-icon>lock</v-icon>
          </v-tab>

          <v-tab-item value="tab-password">
            <password-view v-on:busy="busy = $event"></password-view>
          </v-tab-item>

        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Password from '~/pages/settings/password'

export default {
  name: 'settings-view',
  components: {
    'password-view': Password
  },
  data () {
    return {
      busy: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?08987872